import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxCurrencyModule } from "@ngodings/ngx-currency";
import { AppMaterialModule } from '@app/app-material.module';
import { DateInputComponent } from '@components/date-input/date-input.component';
import { DateRangeInputComponent } from '@components/date-range-input/date-range-input.component';
import { FiltrosComponent } from '@components/filtros/filtros.component';
import { FormComponent } from '@components/form/form.component';
import { HeaderComponent } from '@components/header/header.component';
import { InputComponent } from '@components/input/input.component';
import { MenuComponent } from '@components/menu/menu.component';
import { NavbarComponent } from '@components/navbar/navbar.component';
import { SearchInputComponent } from '@components/search-input/search-input.component';
import { SelectInputComponent } from '@components/select-input/select-input.component';
import { TableComponent } from '@components/table/table.component';
import { TextareaComponent } from '@components/textarea/textarea.component';
import { TimeInputComponent } from '@components/time-input/time-input.component';
import { SeparatorComponent } from '@components/separator/separator.component';
import { AnexosComponent } from '@components/anexos/anexos.component';
import { FileComponent } from '@components/anexos/file/file.component';
import { CheckboxComponent } from '@components/checkbox/checkbox.component'; 
import { MoneyInputComponent } from '@components/money-input/money-input.component';
import { ButtonComponent } from '@components/button/button.component';
import { PaginatorComponent } from '@components/paginator/paginator.component';
import { TelefoneIntlComponent } from './telefone-intl/telefone-intl.component';
import { IndicadorCardComponent } from './indicador-card/indicador-card.component';

@NgModule({
  declarations: [
    DateInputComponent,
    DateRangeInputComponent,
    FiltrosComponent,
    FormComponent,
    HeaderComponent,
    InputComponent,
    MenuComponent,
    NavbarComponent,
    SearchInputComponent,
    SelectInputComponent,
    TableComponent,
    PaginatorComponent,
    TextareaComponent,
    TimeInputComponent,
    SeparatorComponent,
    AnexosComponent,
    FileComponent,
    CheckboxComponent,
    MoneyInputComponent,
    ButtonComponent,
    TelefoneIntlComponent,
    IndicadorCardComponent
  ],
  imports: [
    AppMaterialModule,
    CommonModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxCurrencyModule,
    ReactiveFormsModule,
    RouterModule,  
    FormsModule
  ],
  exports: [
    DateInputComponent,
    DateRangeInputComponent,
    FiltrosComponent,
    FormComponent,
    HeaderComponent,
    InputComponent,
    MenuComponent,
    MenuComponent,
    NavbarComponent,
    SearchInputComponent,
    SelectInputComponent,
    TableComponent,
    PaginatorComponent,
    TextareaComponent,
    TimeInputComponent,
    SeparatorComponent,
    AnexosComponent,
    FileComponent,
    CheckboxComponent,
    MoneyInputComponent,
    ButtonComponent,
    TelefoneIntlComponent,
    IndicadorCardComponent
  ],
  providers: [provideNgxMask()]
})
export class ComponentsModule { }
